import DoubleInput from "@/Layouts/components/InputComponents/DoubleInput";
import { TInputData } from "@/Layouts/types/InputComponents/InputFormExtension";
import { Stack } from "@mui/material";
import { CSSProperties } from "react";
import { TTierCommission } from "../../../../types/spiffSetup";

type MatrixColumnProps = {
	readOnly?: boolean;
	index?: number;
	item?: TTierCommission;
	pvrErrors?: { from: boolean; to: boolean }[];
	fromDisabled?: boolean;
	toDisabled?: boolean;
	onActionUpdate?: (a: number, b: number, c: string, d: string, e: number) => void;
	inputDefinition?: TInputData;
	inputSx?: CSSProperties;
};

const MatrixColumn = (props: MatrixColumnProps) => {
	const {
		readOnly = false,
		index = 0,
		item = null,
		pvrErrors = [],
		fromDisabled = false,
		toDisabled = false,
		onActionUpdate = () => {},
		inputDefinition = null,
		inputSx = {}
	} = props;

	return (
		<Stack>
			<DoubleInput
				firstInput={{
					data: [{ ...inputDefinition, dashed: fromDisabled }],
					value: item?.from?.value ?? 0,
					defaultType: item?.from?.input ?? "Unit",
					disabled: fromDisabled,
					error: Boolean(pvrErrors?.[index]?.from),
					readOnly: true,
					sx: inputSx,
					onActionUpdate: (value) => {
						onActionUpdate?.(0, index, "column", "from", value);
					},
				}}
				secondInput={{
					readOnly,
					data: [{ ...inputDefinition, dashed: toDisabled }],
					value: item?.to?.value ?? 0,
					defaultType: item?.to?.input ?? "Unit",
					disabled: toDisabled,
					error: Boolean(pvrErrors?.[index]?.to),
					sx: inputSx,
					onActionUpdate: (value) => {
						onActionUpdate?.(0, index, "column", "to", value);
					},
				}}
			/>
		</Stack>
	);
};

export default MatrixColumn;
